'use strict';

module.exports = require('./src/standalone/');



//////////////////
// WEBPACK FOOTER
// ./~/autocomplete.js/index.js
// module id = 860
// module chunks = 1